// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_account_login from "./web_account_login.js";
import * as Mapre_web__Web_account_sharing_controller from "./web_account_sharing_controller.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Mapre_web__Web_accounts_model from "./web_accounts_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function cancel(t) {
  Mapre_web__Web_account_sharing_controller.cancel(t.sharing);
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function active(t, generation) {
  if (generation === t.generation) {
    return Curry._1(t.model, undefined).account_form !== undefined;
  } else {
    return false;
  }
}

function failure(t, error) {
  if (!/* tag */ (typeof error !== "object" && typeof error !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Accounts */ 41,
      _0: {
        TAG: /* Failed */ 13,
        _0: error._0
      }
    });
  }
  switch (error) {
    case /* Forbidden */ 1 :
      const form = Curry._1(t.model, undefined).account_form;
      if (form === undefined) {
        return Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: {
            TAG: /* Failed */ 13,
            _0: "Devin rejected this personal access token or its permissions."
          }
        });
      }
      if (form.provider === "devin") {
        return Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: {
            TAG: /* Failed */ 13,
            _0: "Devin rejected this personal access token or its permissions."
          }
        });
      }
      const action = {
        TAG: /* Login_failed */ 10,
        _0: Mapre_web__Web_accounts_model.provider_name(form.provider) + " authorization was denied. Try connecting again."
      };
      return Curry._1(t.emit, {
        TAG: /* Accounts */ 41,
        _0: action
      });
    case /* Unauthorized */ 0 :
    case /* Invalid_response */ 2 :
      Curry._1(t.emit, {
        TAG: /* Accounts */ 41,
        _0: {
          TAG: /* Failed */ 13,
          _0: "Unable to access personal subscriptions."
        }
      });
      return Curry._1(t.failure, error);
  }
}

function request(t, method_, body, path, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, method_, body, path).then(function (result) {
    if (active(t, generation)) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Accounts */ 41,
              _0: {
                TAG: /* Failed */ 13,
                _0: "Invalid account response."
              }
            });
          } else {
            throw exn;
          }
        }
      } else {
        failure(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function load(t, more) {
  const cursor = Stdlib__Option.bind(Curry._1(t.model, undefined).account_form, (function (p) {
    return p.cursor;
  }));
  if (!more) {
    cancel(t);
  }
  const action_1 = crypto.randomUUID();
  const action = {
    TAG: /* Loading */ 7,
    _0: more,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Accounts */ 41,
    _0: action
  });
  const path = "/api/connections?limit=25" + (
    more ? Stdlib__Option.fold("", (function (id) {
        return "&after_id=" + id;
      }), cursor) : ""
  );
  request(t, undefined, undefined, path, (function (json) {
    const action_0 = Stdlib__Array.to_list(Stdlib__Array.map(Mapre_web__Web_accounts_model.decode, Mapre_wire__Json.array(json, "connections")));
    const action_1 = Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor"));
    const action = {
      TAG: /* Loaded */ 8,
      _0: action_0,
      _1: action_1,
      _2: more
    };
    Curry._1(t.emit, {
      TAG: /* Accounts */ 41,
      _0: action
    });
  }));
}

function saved(t, json) {
  const action_0 = Mapre_web__Web_accounts_model.decode(Mapre_wire__Json.get(json, "connection"));
  const action_1 = crypto.randomUUID();
  const action = {
    TAG: /* Saved */ 12,
    _0: action_0,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Accounts */ 41,
    _0: action
  });
  Curry._1(t.changed, undefined);
}

function authenticate(t, form, account) {
  const body = JSON.stringify(Js__Js_dict.fromList(Stdlib.$at({
    hd: [
      "request_id",
      Mapre_wire__Json.str(form.request_id)
    ],
    tl: {
      hd: [
        "expected_version",
        account.version
      ],
      tl: /* [] */ 0
    }
  }, form.provider === "devin" ? ({
      hd: [
        "pat",
        Mapre_wire__Json.str(form.pat)
      ],
      tl: /* [] */ 0
    }) : /* [] */ 0)));
  request(t, undefined, body, "/api/connections/" + (account.id + "/authenticate"), (function (param) {
    const fields = Js__Js_json.decodeObject(param);
    if (fields !== undefined) {
      const fields$1 = Caml_option.valFromOption(fields);
      const match = Js__Js_dict.get(fields$1, "login");
      const match$1 = Js__Js_dict.get(fields$1, "connection");
      if (match !== undefined) {
        if (match$1 !== undefined) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "invalid_account_response"
            });
        }
        const action = {
          TAG: /* Login_pending */ 9,
          _0: Mapre_web__Web_account_login.decode(Date.now(), Caml_option.valFromOption(match))
        };
        return Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: action
        });
      }
      if (match$1 !== undefined) {
        return saved(t, param);
      }
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_account_response"
        });
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_account_response"
      });
  }));
}

function dispatch(t, action) {
  let exit = 0;
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Close */ 0 :
        cancel(t);
        return Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: /* Close */ 0
        });
      case /* Refresh */ 1 :
        if (Curry._1(t.model, undefined).account_form !== undefined) {
          return load(t, false);
        }
        exit = 1;
        break;
      default:
        exit = 1;
    }
  } else {
    switch (action.TAG) {
      case /* Open */ 0 :
        if (Curry._1(t.model, undefined).current_user !== undefined) {
          const action$1 = {
            TAG: /* Open */ 0,
            _0: crypto.randomUUID()
          };
          Curry._1(t.emit, {
            TAG: /* Accounts */ 41,
            _0: action$1
          });
          return load(t, false);
        }
        exit = 1;
        break;
      case /* Sharing */ 15 :
        return Mapre_web__Web_account_sharing_controller.dispatch(t.sharing, action._0);
      default:
        exit = 1;
    }
  }
  if (exit === 1) {
    const form = Curry._1(t.model, undefined).account_form;
    if (form === undefined) {
      return;
    }
    if (!(!form.pending && !form.loading && !Stdlib__Option.fold(false, Mapre_web__Web_account_sharing_model.busy, form.sharing))) {
      return;
    }
    let exit$1 = 0;
    if (/* tag */ typeof action !== "object" && typeof action !== "function") {
      switch (action) {
        case /* More */ 2 :
          if (form.cursor !== undefined) {
            return load(t, true);
          } else {
            return;
          }
        case /* Fresh */ 3 :
          const action$2 = {
            TAG: /* New */ 1,
            _0: crypto.randomUUID()
          };
          return Curry._1(t.emit, {
            TAG: /* Accounts */ 41,
            _0: action$2
          });
        case /* Submit */ 4 :
          if (!Mapre_web__Web_accounts_model.can_save(form)) {
            return;
          }
          Curry._1(t.emit, {
            TAG: /* Accounts */ 41,
            _0: /* Pending */ 5
          });
          const account = form.selected;
          if (account !== undefined) {
            return authenticate(t, form, account);
          }
          const body = JSON.stringify(Js__Js_dict.fromList({
            hd: [
              "request_id",
              Mapre_wire__Json.str(form.request_id)
            ],
            tl: {
              hd: [
                "provider",
                Mapre_wire__Json.str(form.provider)
              ],
              tl: {
                hd: [
                  "label",
                  Mapre_wire__Json.str(Stdlib__String.trim(form.label))
                ],
                tl: /* [] */ 0
              }
            }
          }));
          return request(t, undefined, body, "/api/connections", (function (json) {
            const account = Mapre_web__Web_accounts_model.decode(Mapre_wire__Json.get(json, "connection"));
            Curry._1(t.emit, {
              TAG: /* Accounts */ 41,
              _0: {
                TAG: /* Created */ 11,
                _0: account
              }
            });
            authenticate(t, form, account);
          }));
        case /* Toggle_provider */ 6 :
        case /* Close_provider */ 7 :
          return Curry._1(t.emit, {
            TAG: /* Accounts */ 41,
            _0: action
          });
        default:
          return;
      }
    } else {
      switch (action.TAG) {
        case /* Change */ 2 :
          const action_0 = action._0;
          const action_1 = action._1;
          const action_2 = crypto.randomUUID();
          const action$3 = {
            TAG: /* Edited */ 3,
            _0: action_0,
            _1: action_1,
            _2: action_2
          };
          return Curry._1(t.emit, {
            TAG: /* Accounts */ 41,
            _0: action$3
          });
        case /* Reconnect */ 4 :
        case /* Disconnect */ 5 :
          exit$1 = 2;
          break;
        default:
          return;
      }
    }
    if (exit$1 === 2) {
      const id = action._0;
      const account$1 = Stdlib__List.find_opt((function (x) {
        return x.id === id;
      }), form.items);
      if (account$1 === undefined) {
        return;
      }
      if (account$1.status === "revoked") {
        return;
      }
      Mapre_web__Web_account_sharing_controller.cancel(t.sharing);
      Curry._1(t.emit, {
        TAG: /* Accounts */ 41,
        _0: {
          TAG: /* Sharing */ 15,
          _0: /* Close */ 0
        }
      });
      if (!Caml_obj.caml_equal(action, {
          TAG: /* Reconnect */ 4,
          _0: id
        })) {
        Curry._1(t.emit, {
          TAG: /* Accounts */ 41,
          _0: /* Pending */ 5
        });
        return request(t, "DELETE", JSON.stringify(Js__Js_dict.fromList({
          hd: [
            "expected_version",
            account$1.version
          ],
          tl: /* [] */ 0
        })), "/api/connections/" + account$1.id, (function (param) {
          return saved(t, param);
        }));
      }
      const action_1$1 = crypto.randomUUID();
      const action$4 = {
        TAG: /* Selected */ 6,
        _0: account$1,
        _1: action_1$1
      };
      return Curry._1(t.emit, {
        TAG: /* Accounts */ 41,
        _0: action$4
      });
    }
    
  }
  
}

function create(emit, model, failure, changed) {
  const sharing = Mapre_web__Web_account_sharing_controller.create(emit, model, failure, changed);
  return {
    emit,
    model,
    failure,
    changed,
    sharing,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
